import React, { useEffect, useRef } from 'react';
import { trackAdActivity } from '../lib/adTracker';

interface AdsterraNativeBannerProps {
  className?: string;
}

const AdsterraNativeBanner: React.FC<AdsterraNativeBannerProps> = ({ className = '' }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Create isolated iframe with document write for proper referrer and origin
    const iframe = document.createElement('iframe');
    iframe.style.width = '100%';
    iframe.style.minHeight = '160px';
    iframe.style.border = 'none';
    iframe.style.overflow = 'hidden';
    iframe.scrolling = 'no';
    iframe.setAttribute('title', 'Sponsored Recommendations');

    const htmlContent = `<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8">
    <meta name="referrer" content="always">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <base target="_blank">
    <style>
      * { box-sizing: border-box; margin: 0; padding: 0; }
      html, body {
        width: 100%;
        background: transparent;
        font-family: system-ui, -apple-system, sans-serif;
      }
      #container-c97d5e21d0b90ca23783b0026d0a567c {
        width: 100%;
        display: flex;
        justify-content: center;
      }
    </style>
  </head>
  <body>
    <div id="container-c97d5e21d0b90ca23783b0026d0a567c"></div>
    <script async="async" data-cfasync="false" src="https://pl31307517.profitableratecpmnetwork.com/c97d5e21d0b90ca23783b0026d0a567c/invoke.js"></script>
    <script>
      // Adjust iframe height when content loads
      function checkHeight() {
        var h = document.body.scrollHeight;
        if (h > 40) {
          window.parent.postMessage({ type: 'ADSTERRA_NATIVE_RESIZE', height: h }, '*');
        }
      }
      window.addEventListener('load', function() {
        checkHeight();
        setTimeout(checkHeight, 1000);
        setTimeout(checkHeight, 2500);
      });
      setInterval(checkHeight, 3000);
    </script>
  </body>
</html>`;

    container.innerHTML = '';
    container.appendChild(iframe);

    try {
      const doc = iframe.contentWindow?.document || iframe.contentDocument;
      if (doc) {
        doc.open();
        doc.write(htmlContent);
        doc.close();
      } else {
        iframe.srcdoc = htmlContent;
      }
    } catch {
      iframe.srcdoc = htmlContent;
    }

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'ADSTERRA_NATIVE_RESIZE' && typeof event.data.height === 'number') {
        iframe.style.height = `${Math.max(event.data.height, 160)}px`;
      }
    };

    window.addEventListener('message', handleMessage);

    trackAdActivity({
      eventType: 'impression',
      placement: 'adsterra_native_widget',
    });

    return () => {
      window.removeEventListener('message', handleMessage);
      if (container) {
        container.innerHTML = '';
      }
    };
  }, []);

  return (
    <div className={`adsterra-native-wrapper w-full my-8 p-3 sm:p-4 rounded-3xl bg-slate-50/80 dark:bg-slate-900/50 border border-slate-200/60 dark:border-slate-800 transition-all shadow-sm ${className}`}>
      <div className="flex items-center justify-between mb-3 px-1">
        <span className="text-[9px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500">
          Sponsored Recommendations
        </span>
        <span className="text-[8px] font-semibold text-slate-400/80">Literally Network</span>
      </div>
      
      {/* Container where the Adsterra native banner injects */}
      <div ref={containerRef} className="min-h-[160px] flex items-center justify-center overflow-hidden w-full" />
    </div>
  );
};

export default AdsterraNativeBanner;
